// extracted by mini-css-extract-plugin
module.exports = {"modal":"create-template_modal__3OX_M","closeButton":"create-template_closeButton__3qLSy"};